// extracted by mini-css-extract-plugin
export default {"trendUp":"trend-badge_trendUp__FBZZl","trendDown":"trend-badge_trendDown__Wof95"};